<template>
  <div class="material-table">
    <div class="material-table__actions mb15">
      <a-input-search
        v-model:value="keyword"
        enter-button
        class="w300 mr15"
        placeholder="请输入材料名称关键字"
        @search="search"
      ></a-input-search>
      <a-button type="primary" @click="add">加入待选 >></a-button>
    </div>
    <table-wrapper
      :dataSource="data?.records"
      @onSelectionChange="onSelectionChange"
      :loading="loading"
      :columns="columns"
      :tableHeight="tableHeight"
      :data-config="{format:dataFormat}"
    >
      <template #isInnerContract="{ record, index }">
        <span v-if="record.isInnerContract === true">是</span>
        <span v-if="record.isInnerContract === false">否</span>
      </template>
    </table-wrapper>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, reactive, toRefs, watch, PropType } from "vue";
import { BudgetService } from "@/views/work-manage/budget/budget.service";
import { MaterialRecord } from "@/views/work-manage/budget/budget.interface";
import { columns } from "./constant";

export default defineComponent({
  name: "MaterialTable",
  props: {
    projectId: { type: String, default: "" },
    tableHeight:{type:Number,default:0},
    value: { type: Array as PropType<MaterialRecord[]>, default: [] },
    hideColumn: { type: Array as PropType<any[]>, default: () => [] },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      keyword: string;
      selectedIds: string[];
      selectedRows: MaterialRecord[];
      selectedList: any[];
      columns: any[];
    }>({
      keyword: "",
      selectedIds: [],
      selectedRows: [],
      selectedList: [],
      columns: columns.filter((item) => !props.hideColumn.includes(item.dataIndex)),
    });

    const { data, loading, run } = BudgetService.useMaterialDetailApi();

    const search = async () => {
      await run({
        projectId: props.projectId,
        materialName: state.keyword,
        status: "ysx",
      });
    };

    const onSelectionChange = ({ids, selectedRows}) => {
      state.selectedIds = ids;
      state.selectedRows = selectedRows;
    };

    const add = () => {
      const newValue = [...props.value, ...state.selectedRows];
      emit("update:value", _.uniqBy(newValue, "id"));
    };

    onMounted(async () => {
      await search();
    });

    watch(
      () => props.value,
      async (newVal) => {
        const ids = (newVal || []).map((item) => item.id);
        state.selectedIds = ids;
      },
      { immediate: true }
    );
    const dataFormat =(rows)=>{
      let ids = rows.reduce((pre,cur)=>{
        pre.push(cur.id)
        return pre
      },[])
      return {
        ids,
        selectedRows:rows
      }
    }
    return {
      ...toRefs(state),
      loading,
      data,
      search,
      onSelectionChange,
      add,
      dataFormat
    };
  },
});
</script>

<style lang="less" scoped>
.material-table {
  &__actions {
    display: flex;
    justify-content: space-between;
  }
}
</style>
